import { NgModule } from '@angular/core';
import { AnonymousConsentsModule } from '@spartacus/core';
import {
    AnonymousConsentManagementBannerModule,
    AnonymousConsentsDialogModule,
    ConsentManagementModule
} from '@spartacus/storefront';

@NgModule({
    imports: [
        AnonymousConsentManagementBannerModule,
        AnonymousConsentsDialogModule,
        AnonymousConsentsModule.forRoot(),
        ConsentManagementModule
    ],
    exports: [
        AnonymousConsentManagementBannerModule,
        AnonymousConsentsDialogModule,
        ConsentManagementModule
    ]
})
export class SpartacusConsentFeatureModule {
}
